// client/src/App.js

import "../../App.css";
import CommonContext from "../../commonContext";
import React, { Component, useEffect, useState } from "react";
import { customColors } from "../../utils/customColors";
import { Link } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  FormControl,
  Input,
  useToast,
  Box,
  Text,
  Center,
  FormLabel,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Stack,
  IconButton,
  Flex,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  Checkbox,
  Badge,
  TableCaption,
  TableContainer,
  Select,
} from "@chakra-ui/react";
import { BiArrowBack } from "react-icons/bi";
import { AiFillStepBackward, AiFillStepForward } from "react-icons/ai";
import { FaSortDown, FaSortUp } from "react-icons/fa";
import { MdDelete, MdEdit, MdAdd } from "react-icons/md";
import { IoMdArrowRoundBack } from "react-icons/io";
import { postCall } from "../../utils/requests";
import Utils from "../../utils/utils";
import { decode } from "punycode";
import { BsSortUp } from "react-icons/bs";

function CategoriesList() {
  /* TODO const navigate = useNavigate(); */
  const commonContext = React.useContext(CommonContext);

  const logout = () => {
    console.log("logout");
    localStorage.removeItem("accessToken");
    /* TODO navigate('/'); */
  };

  /* utils */
  const toast = useToast();
  const fileRef = React.useRef(null);

  /* table */
  const [tableContent, setTableContent] = useState([]);
  const [allData, setAllData] = useState([]);

  /* delete form */
  const [isOpenDelete, setIsOpenDelete] = React.useState(false);
  const [isOpenCreate, setIsOpenCreate] = React.useState(false);
  const [isOpenEdit, setIsOpenEdit] = React.useState(false);
  const [idToDelete, setIdToDelete] = React.useState(null);
  const [idToUpdate, setIdToUpdate] = React.useState(null);
  const [nameToDelete, setNameToDelete] = React.useState("");
  const [categoryName, setCategoryName] = React.useState("");
  const [page, setPage] = React.useState(1);
  const [search, setSearch] = React.useState("");
  const [searchFather, setSearchFather] = React.useState("");
  const [advices, setAdvices] = React.useState(false);
  const [trainWithMe, setTrainWithMe] = React.useState(false);
  const [inHome, setInHome] = React.useState(false);
  const [idFather, setIdFather] = React.useState("0");
  const [fathers, setFathers] = React.useState([]);
  const [defaultFather, setDefaultFather] = React.useState(0);
  const [sortOrder, setSortOrder] = React.useState("desc");
  const [sortedBy, setSortedBy] = React.useState("");

  const fetchCategories = async () => {
    postCall("/fetchCat", {}).then((data) => {
      setAllData(
        Array.from(
          data.data.map((item) => {
            let fatherName = "";
            if (
              data !== null &&
              data !== undefined &&
              data.data !== null &&
              data.data !== undefined
            ) {
              try {
                fatherName =
                  item.id_father === 0
                    ? ""
                    : data.data.filter(
                        (obj) => obj.id_category === item.id_father,
                      )[0].name;
              } catch (e) {
                console.log("error: ", e);
              }
            }

            return {
              id: item.id_category,
              name: item.name,
              advices: item.advices,
              trainWithMe: item.train_with_me,
              created_at: Utils.convertDateToIta(item.creation_date, true),
              id_father: item.id_father,
              fatherName: fatherName,
              in_home: item.in_home,
              creation_date: item.creation_date,
            };
          }),
        ),
      );

      setFathers(
        Array.from(
          data.data.map((item) => {
            if (item.id_father === 0) {
              return (
                <option key={item.id_category} value={item.id_category}>
                  {item.name}
                </option>
              );
            }
          }),
        ),
      );

      /* put in tableContent only first n element from allData */
      setTableContent(
        Array.from(
          data.data.map((item) => {
            let fatherName = "";
            if (
              data !== null &&
              data !== undefined &&
              data.data !== null &&
              data.data !== undefined
            ) {
              try {
                fatherName =
                  item.id_father === 0
                    ? ""
                    : data.data.filter(
                        (obj) => obj.id_category === item.id_father,
                      )[0].name;
              } catch (e) {
                console.log("error: ", e);
              }
            }

            return {
              id: item.id_category,
              name: item.name,
              advices: item.advices,
              trainWithMe: item.train_with_me,
              created_at: Utils.convertDateToIta(item.creation_date, true),
              id_father: item.id_father,
              fatherName: fatherName,
              in_home: item.in_home,
              creation_date: item.creation_date,
            };
          }),
        ).slice(page * 7 - 7, page * 7),
      );
    });
  };

  useEffect(() => {
    fetchCategories();

    commonContext.setCurrentPath("Categorie");
    commonContext.setCurrentPage("categorieslist");
  }, []);

  /* BEGIN - EDIT FORM */

  const handleSubmitEdit = async (event) => {
    event.preventDefault();
    if (categoryName === "") {
      toast({
        title: "Errore",
        description: "Inserisci un nome per la categoria",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top",
      });
      return;
    }

    postCall("/updateCat", {
      name: categoryName,
      id_category: idToUpdate,
      advices: advices,
      train_with_me: trainWithMe,
      in_home: inHome ? 1 : 0,
      id_father: idFather === "" ? "0" : idFather,
    }).then((data) => {
      if (data.status === "success") {
        fetchCategories();
        setCategoryName("");
        setAdvices(false);
        setTrainWithMe(false);
        setIdToUpdate(null);

        toast({
          title: "Perfetto",
          description: "Categoria modificata",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top",
        });
        onCloseEdit();
      } else {
        toast({
          title: "Errore",
          description:
            data.error === "15"
              ? "Questo nome esiste già"
              : "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top",
        });
      }
    });
  };

  const onCloseEdit = async () => {
    setIsOpenEdit(false);
  };

  const openEdit = async (
    id,
    name,
    advices,
    trainWithMe,
    in_home,
    idFather,
  ) => {
    console.log("openEdit");
    console.log("inHome", in_home);
    setIdToUpdate(id);
    setCategoryName(name);
    setAdvices(advices);
    setTrainWithMe(trainWithMe);
    setInHome(in_home);

    if (idFather !== 0) {
      setDefaultFather(idFather);
      setIdFather(idFather);
    } else {
      setDefaultFather(0);
      setIdFather(0);
    }

    /* console.log("trainWithMe: ", trainWithMe)
    console.log("advices: ", advices) */

    setIsOpenEdit(true);
  };
  /* END - EDIT FORM */

  /* BEGIN - CREATE FORM */

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      categoryName === "" ||
      categoryName === null ||
      categoryName === undefined
    ) {
      toast({
        title: "Errore",
        description: "Inserisci un nome per la categoria",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top",
      });
      return;
    }

    postCall("/createCat", {
      name: categoryName,
      advices: advices,
      train_with_me: trainWithMe,
      in_home: inHome ? 1 : 0,
      id_father: idFather === "" ? "0" : idFather,
    }).then((data) => {
      if (data.status === "success") {
        fetchCategories();
        setCategoryName("");
        setAdvices(false);
        setTrainWithMe(false);

        toast({
          title: "Perfetto",
          description: "Categoria creata",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top",
        });

        onCloseCreate();
      } else {
        toast({
          title: "Errore",
          description:
            data.error === "15"
              ? "Questo nome esiste già"
              : "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top",
        });
      }
    });
  };

  const onCloseCreate = async () => {
    setIsOpenCreate(false);
  };

  const openCreate = async (id, name) => {
    console.log("openCreate");
    setCategoryName("");
    setIsOpenCreate(true);
    setIdFather(0);
    setDefaultFather(0);
    setInHome(false);
  };
  /* END - CREATE FORM */

  /* BEGIN - DELETE FORM */
  const deleteCategory = async () => {
    console.log("onCloseDelete");

    setIsOpenDelete(false);
    postCall("/deleteCat", {
      id_category: idToDelete,
    }).then((data) => {
      if (data.status === "success") {
        /* remove the deleted category from the list */
        setTableContent(tableContent.filter((item) => item.id !== idToDelete));
        setIdToDelete(null);
        setNameToDelete("");

        toast({
          title: "Perfetto",
          description: "Categoria eliminata",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top",
        });
        fetchCategories();
      } else {
        toast({
          title: "Errore",
          description: "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top",
        });
      }
    });
  };

  const onCloseDelete = async () => {
    setIsOpenDelete(false);
  };

  const openDelete = async (id, name) => {
    console.log("openDelete");
    setIdToDelete(id);
    setNameToDelete(name);
    setIsOpenDelete(true);
  };
  /* END - DELETE FORM */

  /* BEGIN - SORTABLE */

  const handleSortFather = () => {
    setSortedBy("father");
    let allDataSorted = [];

    if (sortOrder === "asc") {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) =>
        a.fatherName.localeCompare(b.fatherName),
      );
      setAllData(allDataSorted);

      setSortOrder("desc");
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) =>
        b.fatherName.localeCompare(a.fatherName),
      );
      setAllData(allDataSorted);

      setSortOrder("asc");
    }

    setTableContent(
      Array.from(
        allDataSorted.map((item) => {
          /* console.log("item: ", item) */
          let fatherName =
            item.id_father === 0
              ? ""
              : allDataSorted.filter((obj) => obj.id === item.id_father)[0]
                  .name;
          /* console.log("itemF: ", fatherName) */

          return {
            id: item.id,
            name: item.name,
            advices: item.advices,
            trainWithMe: item.trainWithMe,
            created_at: Utils.convertDateToIta(item.creation_date, true),
            id_father: item.id_father,
            fatherName: fatherName,
            creation_date: item.creation_date,
          };
        }),
      ).slice(page * 7 - 7, page * 7),
    );
  };

  const handleSortCreated = () => {
    setSortedBy("created");

    let allDataSorted = [];

    if (sortOrder === "asc") {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) =>
        a.creation_date.localeCompare(b.creation_date),
      );
      setAllData(allDataSorted);

      setSortOrder("desc");
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) =>
        b.creation_date.localeCompare(a.creation_date),
      );
      setAllData(allDataSorted);

      setSortOrder("asc");
    }

    setTableContent(
      Array.from(
        allDataSorted.map((item) => {
          let fatherName =
            item.id_father === 0
              ? ""
              : allDataSorted.filter((obj) => obj.id === item.id_father)[0]
                  .name;

          return {
            id: item.id,
            name: item.name,
            advices: item.advices,
            trainWithMe: item.trainWithMe,
            created_at: Utils.convertDateToIta(item.creation_date, true),
            id_father: item.id_father,
            fatherName: fatherName,
            creation_date: item.creation_date,
          };
        }),
      ).slice(page * 7 - 7, page * 7),
    );
  };

  const handleSortName = () => {
    setSortedBy("name");

    let allDataSorted = [];

    if (sortOrder === "asc") {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.name.localeCompare(b.name));
      setAllData(allDataSorted);

      setSortOrder("desc");
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.name.localeCompare(a.name));
      setAllData(allDataSorted);

      setSortOrder("asc");
    }

    setTableContent(
      Array.from(
        allDataSorted.map((item) => {
          let fatherName =
            item.id_father === 0
              ? ""
              : allDataSorted.filter((obj) => obj.id === item.id_father)[0]
                  .name;

          return {
            id: item.id,
            name: item.name,
            advices: item.advices,
            trainWithMe: item.trainWithMe,
            created_at: Utils.convertDateToIta(item.creation_date, true),
            id_father: item.id_father,
            fatherName: fatherName,
            creation_date: item.creation_date,
          };
        }),
      ).slice(page * 7 - 7, page * 7),
    );
  };

  /* END - SORTABLE */

  return (
    <div
      style={{
        width: "100%",
        textAlign: "center",
        height: "100%",
        overflowY: "scroll",
      }}
    >
      {/* BEGIN - FORM TO EDIT A NEW CATEGORY */}
      <Modal isOpen={isOpenEdit} onClose={onCloseEdit}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Modifica categoria</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form>
              <FormControl id="categoryName">
                <FormLabel>Nome</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={categoryName}
                  onChange={(event) => setCategoryName(event.target.value)}
                />

                <Checkbox
                  mr="40px"
                  isChecked={advices}
                  onChange={(e) => setAdvices(e.target.checked)}
                >
                  Video consigli
                </Checkbox>
                <Checkbox
                  mr="40px"
                  isChecked={trainWithMe}
                  onChange={(e) => setTrainWithMe(e.target.checked)}
                >
                  Allenati con me
                </Checkbox>
                <Checkbox
                  mr="40px"
                  isChecked={inHome}
                  onChange={(e) => setInHome(e.target.checked)}
                >
                  In home
                </Checkbox>

                <FormLabel mt="25px">Categoria padre</FormLabel>
                <Select
                  defaultValue={defaultFather}
                  onChange={(event) => setIdFather(event.target.value)}
                  placeholder="Seleziona una categoria padre"
                >
                  {fathers}
                </Select>
              </FormControl>
            </form>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onCloseEdit} mr={3}>
              Indietro
            </Button>
            <Button
              type="submit"
              colorScheme="green"
              onClick={handleSubmitEdit}
            >
              Modifica categoria
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* END - FORM TO EDIT A NEW CATEGORY */}

      {/* BEGIN - FORM TO CREATE A NEW CATEGORY */}
      <Modal isOpen={isOpenCreate} onClose={onCloseCreate}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Crea una nuova categoria</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form onSubmit={handleSubmit}>
              <FormControl id="categoryName">
                <FormLabel>Nome</FormLabel>
                <Input
                  mb="20px"
                  type="text"
                  value={categoryName}
                  onChange={(event) => setCategoryName(event.target.value)}
                />

                <Checkbox
                  mr="40px"
                  isChecked={advices}
                  onChange={(e) => setAdvices(e.target.checked)}
                >
                  Video consigli
                </Checkbox>
                <Checkbox
                  mr="40px"
                  isChecked={trainWithMe}
                  onChange={(e) => setTrainWithMe(e.target.checked)}
                >
                  Allenati con me
                </Checkbox>
                <Checkbox
                  mr="40px"
                  isChecked={inHome}
                  onChange={(e) => setInHome(e.target.checked)}
                >
                  In home
                </Checkbox>

                <FormLabel mt="25px">Categoria padre</FormLabel>
                <Select
                  defaultValue={defaultFather}
                  onChange={(event) => setIdFather(event.target.value)}
                  placeholder="Seleziona una categoria padre"
                >
                  {fathers}
                </Select>
              </FormControl>
            </form>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onCloseCreate} mr={3}>
              Indietro
            </Button>
            <Button type="submit" colorScheme="green" onClick={handleSubmit}>
              Crea categoria
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* END - FORM TO CREATE A NEW CATEGORY */}

      {/* BEGIN - BACK BUTTON */}
      {/* <Stack mt="5" ml="2" mb="5" mr="15" direction='row' spacing={4}>
        <Center><IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          icon={<IoMdArrowRoundBack />}
        /></Center>
        <Box w="5%"></Box>
        <Center >
          <Text
            fontSize="4xl"
            as="b"
            color="teal">
            {commonContext.currentPath}
          </Text>
        </Center>
      </Stack> */}
      {/* END - BACK BUTTON */}

      <hr></hr>

      {/* BEGIN - TOP ROW */}
      <Stack
        pr="20px"
        mt="2%"
        ml="2"
        mb="10"
        direction="row"
        spacing={4}
        justifyContent="space-between"
      >
        <Flex justifyContent="left" w="100%">
          <Button
            mr="20px"
            leftIcon={<MdAdd />}
            colorScheme="green"
            variant="solid"
            onClick={openCreate}
          >
            Nuova categoria
          </Button>
          <Link to="/sortCategories">
            <Button
              leftIcon={<BsSortUp />}
              colorScheme="orange"
              variant="solid"
            >
              Modifica ordine
            </Button>
          </Link>
        </Flex>
        <Flex justifyContent="right" w="100%">
          <Input
            mr="20px"
            borderColor="black"
            w="20%"
            placeholder="Cerca categoria padre..."
            type="text"
            value={searchFather}
            onChange={(event) => {
              setSearchFather(event.target.value);
              setTableContent(
                allData.filter(
                  (item) =>
                    item.fatherName
                      .toLowerCase()
                      .includes(event.target.value.toLowerCase()) &&
                    item.name.toLowerCase().includes(search.toLowerCase()),
                ),
              );
            }}
          />
          <Input
            borderColor="black"
            w="20%"
            placeholder="Cerca nome..."
            type="text"
            value={search}
            onChange={(event) => {
              setSearch(event.target.value);
              setTableContent(
                allData.filter(
                  (item) =>
                    item.name
                      .toLowerCase()
                      .includes(event.target.value.toLowerCase()) &&
                    item.fatherName
                      .toLowerCase()
                      .includes(searchFather.toLowerCase()),
                ),
              );
            }}
          />
        </Flex>
      </Stack>
      {/* END - TOP ROW */}

      {/* BEGIN - DELETE FROM */}
      <AlertDialog isOpen={isOpenDelete} onClose={onCloseDelete}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Elimina categoria
            </AlertDialogHeader>

            <AlertDialogBody>
              Vuoi eliminare definitivamente la categoria "{nameToDelete}"?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={onCloseDelete}>Indietro</Button>
              <Button colorScheme="red" onClick={deleteCategory} ml={3}>
                Elimina
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      {/* END - DELETE FORM */}
      {allData.length < 1 && (
        <Flex h="300px" alignItems="center" justifyContent="center">
          <Text fontSize="xl" as="b" color="teal">
            Nessuna categoria
          </Text>
        </Flex>
      )}
      {/* BEGIN - TABLE */}
      {allData.length > 0 && (
        <TableContainer h="100%">
          <Table
            variant="striped"
            colorScheme="blue"
            w="100%"
            sx={{ tableLayout: "fixed" }}
          >
            {/* <TableCaption>Elenco delle categorie</TableCaption> */}
            <Thead>
              <Tr>
                <Th w="5%">ID</Th>
                <Th _hover={{ cursor: "pointer" }} onClick={handleSortName}>
                  <Flex align="center">
                    Nome
                    {sortedBy === "name" && sortOrder === "asc" && (
                      <FaSortDown />
                    )}{" "}
                    {sortedBy === "name" && sortOrder === "desc" && (
                      <FaSortUp />
                    )}
                  </Flex>
                </Th>
                <Th _hover={{ cursor: "pointer" }} onClick={handleSortFather}>
                  <Flex align="center">
                    Categoria padre
                    {sortedBy === "father" && sortOrder === "asc" && (
                      <FaSortDown />
                    )}{" "}
                    {sortedBy === "father" && sortOrder === "desc" && (
                      <FaSortUp />
                    )}
                  </Flex>
                </Th>
                <Th w="8%">In Home</Th>
                <Th w="8%">Video consigli</Th>
                <Th w="8%">Allenati con me</Th>
                <Th
                  _hover={{ cursor: "pointer" }}
                  onClick={handleSortCreated}
                  w="15%"
                >
                  <Flex align="center">
                    Creata il{" "}
                    {sortedBy === "created" && sortOrder === "asc" && (
                      <FaSortDown />
                    )}{" "}
                    {sortedBy === "created" && sortOrder === "desc" && (
                      <FaSortUp />
                    )}
                  </Flex>
                </Th>
                <Th w="8%"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {tableContent.map((item) => (
                <Tr key={item.id}>
                  <Td>{item.id}</Td>
                  <Td
                    title={item.name}
                    overflowX="hidden"
                    overflow="hidden"
                    textOverflow="ellipsis"
                  >
                    {item.name}
                  </Td>
                  <Td
                    title={item.fatherName}
                    overflowX="hidden"
                    overflow="hidden"
                    textOverflow="ellipsis"
                  >
                    {item.fatherName}
                  </Td>
                  <Td>
                    {item.in_home === 1 ? (
                      <Badge variant="subtle" colorScheme="green">
                        Sì
                      </Badge>
                    ) : (
                      <Badge variant="subtle" colorScheme="red">
                        No
                      </Badge>
                    )}
                  </Td>
                  <Td>
                    {item.advices === 1 ? (
                      <Badge variant="subtle" colorScheme="green">
                        Sì
                      </Badge>
                    ) : (
                      <Badge variant="subtle" colorScheme="red">
                        No
                      </Badge>
                    )}
                  </Td>
                  <Td>
                    {item.trainWithMe === 1 ? (
                      <Badge variant="subtle" colorScheme="green">
                        Sì
                      </Badge>
                    ) : (
                      <Badge variant="subtle" colorScheme="red">
                        No
                      </Badge>
                    )}
                  </Td>
                  <Td>{item.created_at}</Td>
                  <Td>
                    <IconButton
                      mr="2"
                      colorScheme="red"
                      aria-label="Call Segun"
                      size="sm"
                      icon={<MdDelete />}
                      onClick={() => {
                        openDelete(item.id, item.name);
                      }}
                    />
                    <IconButton
                      mr="2"
                      colorScheme="orange"
                      aria-label="Call Segun"
                      size="sm"
                      icon={<MdEdit />}
                      onClick={() => {
                        openEdit(
                          item.id,
                          item.name,
                          item.advices === 1,
                          item.trainWithMe === 1,
                          item.in_home === 1,
                          item.id_father,
                        );
                      }}
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
            <Tfoot>
              <Tr>
                <Th w="5%">ID</Th>
                <Th _hover={{ cursor: "pointer" }} onClick={handleSortName}>
                  <Flex align="center">
                    Nome
                    {sortedBy === "name" && sortOrder === "asc" && (
                      <FaSortDown />
                    )}{" "}
                    {sortedBy === "name" && sortOrder === "desc" && (
                      <FaSortUp />
                    )}
                  </Flex>
                </Th>
                <Th _hover={{ cursor: "pointer" }} onClick={handleSortFather}>
                  <Flex align="center">
                    Categoria padre
                    {sortedBy === "father" && sortOrder === "asc" && (
                      <FaSortDown />
                    )}{" "}
                    {sortedBy === "father" && sortOrder === "desc" && (
                      <FaSortUp />
                    )}
                  </Flex>
                </Th>
                <Th w="8%">In Home</Th>
                <Th w="8%">Video consigli</Th>
                <Th w="8%">Allenati con me</Th>
                <Th
                  _hover={{ cursor: "pointer" }}
                  onClick={handleSortCreated}
                  w="15%"
                >
                  <Flex align="center">
                    Creata il{" "}
                    {sortedBy === "created" && sortOrder === "asc" && (
                      <FaSortDown />
                    )}{" "}
                    {sortedBy === "created" && sortOrder === "desc" && (
                      <FaSortUp />
                    )}
                  </Flex>
                </Th>
                <Th w="8%"></Th>
              </Tr>
            </Tfoot>
          </Table>
        </TableContainer>
      )}

      <Center w="100%" mb="4">
        <IconButton
          isRound={true}
          variant="solid"
          colorScheme="teal"
          aria-label="Done"
          fontSize="20px"
          onClick={() => {
            if (page > 1) {
              setTableContent(allData.slice(page * 7 - 14, page * 7 - 7));
              setPage(page - 1);
            }
          }}
          icon={<AiFillStepBackward />}
        />
        <Text ml="4" mr="4">
          {page} / {Math.ceil(allData.length / 7)}
        </Text>
        <IconButton
          isRound={true}
          variant="solid"
          colorScheme="teal"
          aria-label="Done"
          fontSize="20px"
          onClick={() => {
            if (page < Math.ceil(allData.length / 7)) {
              setTableContent(allData.slice(page * 7, page * 7 + 7));
              setPage(page + 1);
            }
          }}
          icon={<AiFillStepForward />}
        />
      </Center>

      {/* END - TABLE */}
    </div>
  );
}

export default CategoriesList;
